import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseOptionAPI } from '@core/_base/crud/models/_base.option-api';
import { TypesUtilsService, ResponseBody, HttpUtilsService } from '@core/_base/crud';
import { environment } from '@env/environment.prod';
import { tap } from 'rxjs/operators';
import { Device } from '../_models/device';

const API_URL = environment.api.host + "/streamax";

@Injectable({
  providedIn: 'root'
})
export class StreamaxService {

  constructor(private http: HttpClient, private utils: TypesUtilsService,private httpUtils: HttpUtilsService) { }
  reload(): Observable<ResponseBody> {   
    return this.http.get<ResponseBody>(API_URL + "/update/vehicle-group");
  }
}

